export default __webpack_public_path__ + "static/media/platinum_tier.5b9cce39.svg";